import { render, staticRenderFns } from "./DepositSourceDetailsOther.vue?vue&type=template&id=1f9ff91f"
import script from "./DepositSourceDetailsOther.vue?vue&type=script&lang=js"
export * from "./DepositSourceDetailsOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports